import React, { FunctionComponent } from 'react';
import { Route } from 'react-router-dom';
import routes from 'routes/projects';

interface IProjects {}

const Projects: FunctionComponent<IProjects> = () => {
  return (
    <>
      {routes.map(({ path, Component }, key) => (
        <Route exact path={path} key={key} component={Component} />
      ))}
    </>
  );
};

export default Projects;
